// Add a mouseover event listener to the target element
document.addEventListener('mouseover', function(event) {
    // Check if the target element has the class 'javascript'
    if (event.target.classList.contains('site-nav__link--has-dropdown') != null) {
        document.querySelectorAll('.site-nav[aria-label="Primary"] .site-nav__link--has-dropdown').forEach(e=> {

            if (!e.classList.contains('active-coll')) {
                e.classList.remove('site-nav--active')
            }
        })
    }

    if (!event.target.closest('#SiteHeader') && document.querySelector('.index-new_navs') != null) {
        document.querySelector(`.new_navs`).classList.add('inactive-index')
    }

    if (!event.target.closest('#SiteHeader') && !document.body.classList.contains('already')  && document.querySelector('.index-new_navs') == null) {
        inSub()
        document.body.classList.add('already')
    }
});

document.querySelectorAll('.site-nav[aria-label="Primary"] .site-nav__link--has-dropdown').forEach(e=> {
    e.addEventListener('mouseover', function() {
        e.classList.add('site-nav--active')
        var collHandle = e.href
        document.querySelector(`.new_navs`).classList.add('loading-state')
        subMenuFetch(collHandle)

        document.body.classList.remove('already')
    })
})


inSub()

function inSub() {
    if ( document.querySelector('.site-nav--active[data-type="collection_link"]') != null ) {
        var activeLink = document.querySelector('.site-nav--active[data-type="collection_link"]')
        activeLink.classList.add('active-coll')
    
        var collHandle = activeLink.href
        document.querySelector(`.new_navs`).classList.add('loading-state')
        subMenuFetch(collHandle)
    }
}



function subMenuFetch(collection) {
    fetch(`${collection}?section_id=submenu-fetcher`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = document.querySelector(`.new_navs`);
      const source = html.querySelector(`.new_navs`);

      destination.classList.remove('loading-state')
      console.log(source)
      
      if (source && destination) destination.innerHTML = source.innerHTML;
      destination.classList.remove('inactive-index')

    });
}

document.querySelectorAll('.product__thumb').forEach(thumb => {
    thumb.addEventListener('click', function(event) {
        event.preventDefault(); 
        
       
        const clickedImageSrc = this.querySelector('img').getAttribute('data-srcset').split(', ')[0].split(' ')[0];

        
        const mainImage = document.querySelector('.photoswipe__image');
        mainImage.setAttribute('srcset', this.querySelector('img').getAttribute('data-srcset'));
        mainImage.setAttribute('data-photoswipe-src', clickedImageSrc);
    });
});



document.addEventListener('DOMContentLoaded', function() {
    // Check if the current page has the class 'new-product-page'
    if (document.querySelector('.new-product-page')) {
        // Function to check if the device is mobile
        function isMobile() {
            return window.innerWidth <= 768;  
        }

        // Execute if on a mobile device
        if (isMobile()) {
            var mainSliderElement = document.querySelector('[data-product-photos]');
            var thumbSliderElement = document.querySelector('[data-product-thumbs]');

            if (mainSliderElement && thumbSliderElement) {
                // Initialize the main slider
                var mainSlider = new Flickity(mainSliderElement, {
                    cellAlign: 'left',
                    contain: true,
                    wrapAround: true,
                    prevNextButtons: true,
                    pageDots: false,
                    fade: true,
                    asNavFor: '.product__thumbs--scroller'
                });

                // Initialize the thumbnail slider
                var thumbSlider = new Flickity(thumbSliderElement, {
                    asNavFor: '[data-product-photos]',
                    contain: true,
                    pageDots: false,
                    prevNextButtons: false,
                    cellAlign: 'left',
                    wrapAround: true
                });
            }
        }
    }
});


